(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function todayIso() {
    var now = new Date();
    var m = String(now.getMonth() + 1).padStart(2, '0');
    var d = String(now.getDate()).padStart(2, '0');
    return now.getFullYear() + '-' + m + '-' + d;
  }

  function nowHm() {
    var now = new Date();
    return String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0');
  }

  function isAdult(iso) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (!match) return false;
    var birth = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    var cutoff = new Date();
    cutoff.setFullYear(cutoff.getFullYear() - 18);
    return birth <= cutoff;
  }

  function formatSlot(date, time) {
    if (!date || !time) return '';
    var parts = date.split('-').map(Number);
    var hm = time.split(':').map(Number);
    var dt = new Date(parts[0], parts[1] - 1, parts[2], hm[0], hm[1]);
    if (Number.isNaN(dt.getTime())) return (date + ' ' + time).trim();
    var datePart = dt.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    var timePart = dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    var tz = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
      .formatToParts(dt)
      .find(function (part) {
        return part.type === 'timeZoneName';
      });
    return tz && tz.value ? datePart + ' · ' + timePart + ' ' + tz.value : datePart + ' · ' + timePart;
  }

  function isQuestionsValue(value) {
    var lower = String(value || '').toLowerCase();
    return lower.indexOf('questions') !== -1 && lower.indexOf('yes') !== -1 && lower.indexOf('no') !== -1;
  }

  function showError(el, message) {
    if (!el) return;
    var field = el.closest('.pdp-customer-info__field') || el.closest('fieldset') || el.parentElement;
    var existing = field && field.querySelector('[data-live-error]');
    if (!existing && field) {
      existing = document.createElement('p');
      existing.className = 'pdp-customer-info__error';
      existing.setAttribute('data-live-error', 'true');
      existing.setAttribute('role', 'alert');
      field.appendChild(existing);
    }
    if (existing) {
      existing.textContent = message;
      existing.classList.remove('is-hidden');
    }
    el.classList.add('bruja-input--error');
  }

  function clearErrors(root) {
    root.querySelectorAll('[data-live-error]').forEach(function (node) {
      node.remove();
    });
    root.querySelectorAll('.bruja-input--error').forEach(function (node) {
      node.classList.remove('bruja-input--error');
    });
    root.querySelectorAll('[data-pdp-slot-error]').forEach(function (node) {
      node.classList.add('is-hidden');
      node.textContent = '';
    });
  }

  ready(function () {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    var strings = {
      required: root.getAttribute('data-msg-required') || 'This field is required.',
      under18: root.getAttribute('data-msg-under18') || 'You must be 18 or older to purchase this service.',
      photo: root.getAttribute('data-msg-photo') || 'A recent photo is required.',
      slots: root.getAttribute('data-msg-slots') || 'Please choose at least one start date and time.',
      incomplete: root.getAttribute('data-msg-incomplete') || 'Each option needs both a date and a time.',
      past: root.getAttribute('data-msg-past') || 'Please choose a date and time that is still upcoming.',
      ritual: root.getAttribute('data-msg-ritual') || 'Please choose one ritual focus.',
      option: root.getAttribute('data-msg-option') || 'Option {n}',
      question: root.getAttribute('data-msg-question') || 'Your question or intention',
      questionN: root.getAttribute('data-msg-question-n') || 'Question {n}',
      inStock: root.getAttribute('data-msg-in') || 'In stock',
      outStock: root.getAttribute('data-msg-out') || 'Out of stock',
      save: root.getAttribute('data-msg-save') || 'Save {percent}%',
    };

    var variantScript = document.querySelector('[data-pdp-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
    } catch (err) {
      variants = [];
    }

    var form = root.querySelector('[data-pdp-form]');
    var idInput = root.querySelector('[data-pdp-variant-id]');
    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    var selected = {};
    var optionGroups = root.querySelectorAll('[data-option-index]');
    optionGroups.forEach(function (group) {
      var selectedBtn = group.querySelector('.product-options-item--selected');
      if (selectedBtn) selected[selectedBtn.getAttribute('data-option-index')] = selectedBtn.getAttribute('data-option-value');
    });

    function currentVariant() {
      return variants.find(function (variant) {
        return (variant.options || []).every(function (value, index) {
          if (selected[index] == null) return variant.options.length === 1 || true;
          return value === selected[String(index)] || value === selected[index];
        });
      }) || variants.find(function (variant) {
        return Number(variant.id) === Number(idInput && idInput.value);
      }) || variants[0];
    }

    function findVariant() {
      var match = variants.find(function (variant) {
        return (variant.options || []).every(function (value, index) {
          var chosen = selected[String(index)] || selected[index];
          if (chosen == null) return variant.options.length <= 1;
          return value === chosen;
        });
      });
      return match || currentVariant();
    }

    function updatePrice(variant) {
      if (!variant) return;
      var priceNow = root.querySelector('[data-pdp-price-now]');
      var compare = root.querySelector('[data-pdp-price-compare]');
      var save = root.querySelector('[data-pdp-save]');
      var stock = root.querySelector('[data-pdp-stock]');
      var box = root.querySelector('[data-pdp-price]');
      if (priceNow) priceNow.textContent = variant.price;
      if (variant.compare && variant.save != null) {
        if (box) box.classList.add('pdp__price--sale');
        if (compare) {
          compare.textContent = variant.compare;
          compare.classList.remove('is-hidden');
        }
        if (save) {
          save.textContent = strings.save.replace('{percent}', String(variant.save));
          save.classList.remove('is-hidden');
        }
      } else {
        if (box) box.classList.remove('pdp__price--sale');
        if (compare) compare.classList.add('is-hidden');
        if (save) save.classList.add('is-hidden');
      }
      if (stock) {
        stock.textContent = variant.available ? strings.inStock : strings.outStock;
        stock.classList.toggle('pdp__stock--out', !variant.available);
        stock.classList.toggle('pdp__stock--in', variant.available);
      }
      if (idInput) idInput.value = variant.id;
      var atc = root.querySelector('[data-pdp-atc]');
      if (atc) atc.disabled = !variant.available;
    }

    root.querySelectorAll('[data-pdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-option-index');
        selected[index] = btn.getAttribute('data-option-value');
        btn.parentElement.querySelectorAll('[data-pdp-option]').forEach(function (other) {
          other.classList.toggle('product-options-item--selected', other === btn);
        });
        updatePrice(findVariant());
        syncQuestions();
      });
    });

    var qty = 1;
    function setQty(next) {
      qty = Math.min(99, Math.max(1, next));
      if (qtyInput) qtyInput.value = String(qty);
      root.querySelectorAll('[data-pdp-qty-value]').forEach(function (node) {
        node.textContent = String(qty);
      });
      root.querySelectorAll('[data-pdp-qty-minus]').forEach(function (btn) {
        btn.disabled = qty <= 1;
      });
      syncQuestions();
    }
    root.querySelectorAll('[data-pdp-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(qty - 1);
      });
    });
    root.querySelectorAll('[data-pdp-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(qty + 1);
      });
    });
    setQty(1);

    var questionsBox = root.querySelector('[data-pdp-questions]');
    var questionList = root.querySelector('[data-pdp-question-list]');
    var questionTemplate = questionList && questionList.querySelector('[data-pdp-question]');

    function questionsSelected() {
      if (root.getAttribute('data-tarot') !== 'true') return false;
      var variant = findVariant();
      return (variant && variant.options ? variant.options : []).some(isQuestionsValue);
    }

    function syncQuestions() {
      if (!questionsBox || !questionList || !questionTemplate) return;
      var on = questionsSelected();
      questionsBox.classList.toggle('is-hidden', !on);
      var qtyWrap = root.querySelector('[data-pdp-qty-main]');
      if (qtyWrap) {
        if (on) questionsBox.parentNode.insertBefore(qtyWrap, questionsBox);
        else {
          var atc = root.querySelector('[data-pdp-atc]');
          if (atc) atc.parentNode.insertBefore(qtyWrap, atc);
        }
      }
      if (!on) {
        questionList.querySelectorAll('[data-pdp-question]').forEach(function (node, index) {
          if (index > 0) node.remove();
        });
        var field = questionList.querySelector('[data-pdp-question-field]');
        if (field) {
          field.removeAttribute('required');
          field.disabled = true;
        }
        return;
      }
      while (questionList.querySelectorAll('[data-pdp-question]').length < qty) {
        questionList.appendChild(questionTemplate.cloneNode(true));
      }
      questionList.querySelectorAll('[data-pdp-question]').forEach(function (node, index) {
        if (index >= qty) {
          node.remove();
          return;
        }
        var field = node.querySelector('[data-pdp-question-field]');
        var label = node.querySelector('[data-pdp-question-label]');
        field.disabled = false;
        field.required = true;
        field.name = qty === 1 ? 'properties[Question / Intention]' : 'properties[Question ' + (index + 1) + ']';
        if (label) {
          label.innerHTML =
            (qty === 1 ? strings.question : strings.questionN.replace('{n}', String(index + 1))) +
            '<span> *</span>';
        }
      });
    }

    root.querySelectorAll('[data-pdp-ritual] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('.pdp-ritual-focus__option').forEach(function (label) {
          label.classList.toggle('pdp-ritual-focus__option--selected', label.querySelector('input').checked);
        });
      });
    });

    function bindSlots(group) {
      var list = group.querySelector('[data-pdp-slot-list]');
      var addBtn = group.querySelector('[data-pdp-slot-add]');
      var kind = group.getAttribute('data-slot-kind');
      var first = list.querySelector('[data-pdp-slot]');
      var max = 3;

      function rename() {
        var slots = list.querySelectorAll('[data-pdp-slot]');
        slots.forEach(function (slot, index) {
          var label = slot.querySelector('.pdp-reiki-availability__slot-label');
          if (label) label.textContent = strings.option.replace('{n}', String(index + 1));
          var prop = slot.querySelector('[data-pdp-slot-prop]');
          if (prop) {
            prop.name =
              kind === 'work'
                ? 'properties[Work start ' + (index + 1) + ']'
                : 'properties[Preferred time ' + (index + 1) + ']';
          }
          var remove = slot.querySelector('[data-pdp-slot-remove]');
          if (remove) remove.classList.toggle('is-hidden', slots.length <= 1);
        });
        if (addBtn) addBtn.classList.toggle('is-hidden', slots.length >= max);
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (list.querySelectorAll('[data-pdp-slot]').length >= max) return;
          var clone = first.cloneNode(true);
          clone.querySelectorAll('input').forEach(function (input) {
            if (input.type !== 'hidden') input.value = '';
            else input.value = '';
          });
          list.appendChild(clone);
          clone.querySelector('[data-pdp-slot-remove]').addEventListener('click', onRemove);
          rename();
        });
      }

      function onRemove(event) {
        var slot = event.currentTarget.closest('[data-pdp-slot]');
        if (list.querySelectorAll('[data-pdp-slot]').length <= 1) return;
        slot.remove();
        rename();
      }

      list.querySelectorAll('[data-pdp-slot-remove]').forEach(function (btn) {
        btn.addEventListener('click', onRemove);
      });
      rename();
    }

    root.querySelectorAll('[data-pdp-slots]').forEach(bindSlots);

    var photo = root.querySelector('[data-pdp-photo]');
    var photoProp = root.querySelector('[data-pdp-photo-prop]');
    if (photo && photoProp) {
      photo.addEventListener('change', function () {
        var file = photo.files && photo.files[0];
        photoProp.value = file
          ? file.name + ' — email this photo after checkout'
          : '';
      });
    }

    var customPhotos = root.querySelector('[data-pdp-custom-photos]');
    if (customPhotos) {
      var customPhotoRows = Array.prototype.slice.call(customPhotos.querySelectorAll('[data-pdp-custom-photo-row]'));
      var customPhotoAdd = customPhotos.querySelector('[data-pdp-custom-photo-add]');

      function syncCustomPhotos() {
        var visibleRows = customPhotoRows.filter(function (row) {
          return !row.classList.contains('is-hidden');
        });
        visibleRows.forEach(function (row) {
          var input = row.querySelector('[data-pdp-custom-photo]');
          var remove = row.querySelector('[data-pdp-custom-photo-remove]');
          if (remove) remove.classList.toggle('is-hidden', visibleRows.length === 1 && !(input && input.files && input.files.length));
        });
        if (customPhotoAdd) customPhotoAdd.classList.toggle('is-hidden', visibleRows.length >= customPhotoRows.length);
      }

      customPhotoRows.forEach(function (row) {
        var input = row.querySelector('[data-pdp-custom-photo]');
        var remove = row.querySelector('[data-pdp-custom-photo-remove]');
        if (input) input.addEventListener('change', syncCustomPhotos);
        if (remove) {
          remove.addEventListener('click', function () {
            if (input) input.value = '';
            var visibleCount = customPhotoRows.filter(function (candidate) {
              return !candidate.classList.contains('is-hidden');
            }).length;
            if (visibleCount > 1) row.classList.add('is-hidden');
            syncCustomPhotos();
          });
        }
      });

      if (customPhotoAdd) {
        customPhotoAdd.addEventListener('click', function () {
          var nextRow = customPhotoRows.find(function (row) {
            return row.classList.contains('is-hidden');
          });
          if (!nextRow) return;
          nextRow.classList.remove('is-hidden');
          var nextInput = nextRow.querySelector('[data-pdp-custom-photo]');
          if (nextInput) nextInput.focus();
          syncCustomPhotos();
        });
      }

      syncCustomPhotos();
    }

    var dob = root.querySelector('[data-pdp-dob]');
    if (dob) dob.setAttribute('max', todayIso());

    function fillSlots(group) {
      var error = group.querySelector('[data-pdp-slot-error]');
      var slots = group.querySelectorAll('[data-pdp-slot]');
      var complete = [];
      var incomplete = false;
      slots.forEach(function (slot) {
        var date = (slot.querySelector('[data-pdp-slot-date]') || {}).value || '';
        var time = (slot.querySelector('[data-pdp-slot-time]') || {}).value || '';
        var prop = slot.querySelector('[data-pdp-slot-prop]');
        if (date && time) {
          if (date < todayIso() || (date === todayIso() && time < nowHm())) {
            complete.push({ past: true });
          } else {
            complete.push({ value: formatSlot(date, time) });
          }
          if (prop) {
            prop.disabled = false;
            prop.value = formatSlot(date, time);
          }
        } else if (date || time) {
          incomplete = true;
          if (prop) prop.disabled = true;
        } else if (prop) {
          prop.disabled = true;
          prop.value = '';
        }
      });
      if (error) {
        if (complete.some(function (item) { return item.past; })) {
          error.textContent = strings.past;
          error.classList.remove('is-hidden');
          return false;
        }
        if (incomplete) {
          error.textContent = strings.incomplete;
          error.classList.remove('is-hidden');
          return false;
        }
        if (!complete.length) {
          error.textContent = strings.slots;
          error.classList.remove('is-hidden');
          return false;
        }
        error.classList.add('is-hidden');
      }
      return true;
    }

    function isServicePdp() {
      return (
        root.getAttribute('data-tarot') === 'true' ||
        root.getAttribute('data-velacion') === 'true' ||
        root.getAttribute('data-reversal') === 'true' ||
        root.getAttribute('data-reiki') === 'true' ||
        root.getAttribute('data-custom-work') === 'true'
      );
    }

    function stripLeakedProperties() {
      if (isServicePdp()) return;
      root.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(function (field) {
        field.disabled = true;
        field.removeAttribute('required');
        field.name = '';
      });
    }

    function validate() {
      clearErrors(root);
      if (!isServicePdp()) {
        stripLeakedProperties();
        return true;
      }
      var ok = true;
      var requiredMsg = strings.required;
      var name = root.querySelector('#pdp-full-name');
      var dobField = root.querySelector('[data-pdp-dob]');
      if (name && !name.value.trim()) {
        showError(name, requiredMsg);
        ok = false;
      }
      if (dobField) {
        if (!dobField.value) {
          showError(dobField, requiredMsg);
          ok = false;
        } else if (!isAdult(dobField.value)) {
          showError(dobField, strings.under18);
          ok = false;
        }
      }
      if (root.getAttribute('data-reiki') === 'true') {
        if (!photoProp || !photoProp.value) {
          showError(photo || photoProp, strings.photo);
          ok = false;
        }
        var focus = root.querySelector('#pdp-focus');
        if (focus && !focus.value.trim()) {
          showError(focus, requiredMsg);
          ok = false;
        }
      }
      if (root.getAttribute('data-custom-work') === 'true') {
        var customWork = root.querySelector('[data-pdp-custom-work]');
        if (customWork && !customWork.value.trim()) {
          showError(customWork, requiredMsg);
          ok = false;
        }
      }
      if (questionsSelected()) {
        root.querySelectorAll('[data-pdp-question-field]').forEach(function (field) {
          if (!field.disabled && !field.value.trim()) {
            showError(field, requiredMsg);
            ok = false;
          }
        });
      }
      var ritual = root.querySelector('[data-pdp-ritual]');
      if (ritual && !ritual.querySelector('input:checked')) {
        showError(ritual, strings.ritual);
        ok = false;
      }
      root.querySelectorAll('[data-pdp-slots]').forEach(function (group) {
        if (!fillSlots(group)) ok = false;
      });
      return ok;
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!validate()) {
          event.preventDefault();
          var first = root.querySelector('.bruja-input--error, [data-pdp-slot-error]:not(.is-hidden)');
          if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    var sticky = root.querySelector('[data-pdp-sticky]');
    var primary = document.getElementById('pdp-primary-atc');
    var stickySubmit = root.querySelector('[data-pdp-sticky-submit]');
    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
    if (sticky && primary) {
      var updateSticky = function () {
        var visible = primary.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    var gallery = root.querySelector('[data-pdp-gallery]');
    if (gallery) {
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-thumb]'));
      var image = gallery.querySelector('[data-pdp-gallery-image]');
      var count = gallery.querySelector('[data-pdp-gallery-count]');
      var index = 0;
      function show(next) {
        if (!thumbs.length) return;
        index = (next + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        if (image) {
          image.src = thumb.getAttribute('data-src');
          image.alt = thumb.getAttribute('data-alt') || '';
        }
        thumbs.forEach(function (btn, i) {
          btn.classList.toggle('pdp__thumb--active', i === index);
          btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        if (count) count.textContent = index + 1 + ' / ' + thumbs.length;
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          show(i);
        });
      });
      var prev = gallery.querySelector('[data-pdp-gallery-prev]');
      var next = gallery.querySelector('[data-pdp-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
    }

    var back = root.querySelector('[data-pdp-back]');
    if (back) {
      back.addEventListener('click', function () {
        if (window.history.length > 1) window.history.back();
        else window.location.href = root.getAttribute('data-shop-url') || '/pages/shop';
      });
    }

    stripLeakedProperties();
    syncQuestions();
    updatePrice(findVariant());
  });
})();
